import { Link, useLoaderData } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { ShopifySyncSection } from "./shopify-sync-section";

export function ShopifySyncPage() {
  const { shopifySyncSettings, shopifySyncHistory, totalLocalOrders } = useLoaderData({
    from: "/_authenticated/data-sync/shopify-orders",
  }) as {
    shopifySyncSettings: {
      intervalMs: number;
      lastSyncedAt: string | null;
      schedulerActive: boolean;
      backfillCompletedAt: string | null;
    };
    shopifySyncHistory: any[];
    totalLocalOrders: number;
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Shopify Order Sync"
        description="Mirror Shopify orders and line items locally"
        actions={
          <Button variant="outline" size="sm" asChild>
            <Link to="/data-sync">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back
            </Link>
          </Button>
        }
      />

      <ShopifySyncSection
        initialSettings={shopifySyncSettings}
        initialHistory={shopifySyncHistory}
        totalOrders={totalLocalOrders}
      />
    </div>
  );
}
